module.exports = __webpack_public_path__ + "static/media/document.14208168.svg";